import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { UserService, CourseService } from "@bt/core/services";
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from "@bt/core/base";
import { AdminInviteModel } from "@bt/core/models/adminInviteModel.model";
import {faArrowLeft,faArrowRight} from "@fortawesome/free-solid-svg-icons"

@Component({
  selector: "app-create-admin",
  templateUrl: "./create-admin.component.html",
  styleUrls: ["./create-admin.component.scss"]
})
export class CreateAdminComponent extends BaseComponent implements OnInit, OnDestroy {
  // public newUser: UserModel;
  @ViewChild('customNotification') customNotificationTmpl;

  faArrowLeft= faArrowLeft;
  faArrowRight=faArrowRight;

  public adminform: FormGroup;
  public isSubmitted: boolean = false;
  private fioPattern = /^[a-zA-Zа-яёА-Я-\s]+$/; // /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
  private notifier: NotifierService;
  private adminInviteModel: AdminInviteModel;
  public errors: string[];

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
    private router: Router,
    notifierService: NotifierService
  ) {

    super();
    this.notifier = notifierService;

  }

  ngOnInit(): void {
    this.adminInviteModel = new AdminInviteModel();

    this.adminform = this.fb.group({
      email: ["", [Validators.required, Validators.pattern(this.emailPattern)]],
      // lastName: ["", [Validators.required, Validators.maxLength(50)]],
      // firstName: ["", [Validators.required, Validators.maxLength(50)]],
      // middleName: ["", [Validators.required, Validators.maxLength(50)]],
      FIO: ["", [Validators.required, Validators.maxLength(100), Validators.pattern(this.fioPattern)]],
      greeting: ["Добро пожаловать на платформу CyberCube!"]
    });
  }
  ngOnDestroy(): void {
    this.adminform.reset();
  }

  get email() { return this.adminform.get('email'); }
  // get lastName() { return this.adminform.get('lastName'); }
  // get firstName() { return this.adminform.get('firstName'); }
  // get middleName() { return this.adminform.get('firstName'); }
  get FIO() { return this.adminform.get('FIO'); }
  get greeting() { return this.adminform.get('greeting'); }

  public validateForm(): boolean {

    if (this.email.invalid || this.FIO.invalid) {
      this.notifier.notify("error", "Форма заполнена неправильно");
      return false;
    }

    return true;
  }

  public createAdmin() {

    var t = this;
    this.isSubmitted = true;
    t.setLoading(true);
    if (!this.validateForm()) {
      t.setLoading(false);
      return;
    }
    
    var fio = this.adminform.value.FIO.split(" ");

    this.adminInviteModel.email = this.adminform.value.email;
    this.adminInviteModel.lastName = fio[0];
    this.adminInviteModel.firstName = fio[1];
    this.adminInviteModel.middleName = fio[2];
    this.adminInviteModel.greeting = this.adminform.value.greeting;

    this.userService.createAdmin(this.adminInviteModel)
      .then((resp) => {
        t.setLoading(false);
        if (resp.data === true) {
          this.router.navigateByUrl("all-users");
          this.notifier.notify('success', 'Приглашение отправлено на e-mail');
        }
        else {
          resp.errorMsgs.forEach(msg => {
            this.notifier.notify('error', msg);
            this.adminInviteModel = new AdminInviteModel();
          });

          console.error("Error #" + resp.errorCode + ": " + resp.errorMsgs);
        }
      })

      .catch((error) => {
        if (error.error && error.error.errorMsgs) {
          error.error.errorMsgs.forEach(msg => {
            this.notifier.notify('error', msg);
          });
          this.adminInviteModel = new AdminInviteModel();
          t.setLoading(false);
        }
      });
  }

  public resetForm() {
    this.adminform.reset();
  }


}


// WEBPACK FOOTER //
// ./src/app/superadmin/create-admin/create-admin.component.ts